class AuthenticationDrawer extends window.BAO.CustomElement() {
  editState = false

  setupListeners () {
    super.setupListeners()

    this.showRegistrationForm = this.showRegistrationForm.bind(this)
    this.showLoginForm = this.showLoginForm.bind(this)

    this.listeners.add(
      this.els['register-link'].element,
      'click',
      this.showRegistrationForm,
    )

    this.listeners.add(
      this.els['login-link'].element,
      'click',
      this.showLoginForm,
    )
  }

  showRegistrationForm () {
    this.els['login-drawer'].element.removeAttribute('open')
    this.els['register-drawer'].element.setAttribute('open', '')
    this.els['register-drawer'].element
      .querySelector('input[type="date"]')
      .addEventListener('blur', e => {
        e.target.classList.remove('frm-Form_Date')
        e.target.parentNode.querySelector('label').style.opacity = '0.7'

        if (e.target.value === '') {
          e.target.classList.add('frm-Form_Date')
          e.target.parentNode.querySelector('label').style.opacity = '0'
        }
      })
  }

  showLoginForm () {
    this.els['register-drawer'].element.removeAttribute('open')
    this.els['login-drawer'].element.setAttribute('open', '')
  }
}

if (!customElements.get('authentication-drawer')) {
  customElements.define('authentication-drawer', AuthenticationDrawer)
}
